import { UseAttachmentPreviewModalLogicProps } from './types'

export const useAttachmentPreviewModalLogic = ({
  attachmentIndex,
  onRemove,
}: UseAttachmentPreviewModalLogicProps) => {
  const isImage = (mimetype: string, filename: string) => {
    const extension = filename.split('.').pop()?.toLowerCase()
    return (
      mimetype.startsWith('image/') ||
      ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension || '')
    )
  }

  const isPdf = (mimetype: string, filename: string) => {
    const extension = filename.split('.').pop()?.toLowerCase()
    return extension === 'pdf' || mimetype === 'application/pdf'
  }

  const handleRemove = () => {
    onRemove(attachmentIndex)
  }

  return {
    handleRemove,
    isImage,
    isPdf,
  }
}
